import useFetchPublisherBookPerformance from "api/AdminReports/useFetchPublisherBookPerformance";
import { useState } from "react";
import moment from "moment";
import BookCard from "admin/AllBooks2/BookCard";
import { MetricCard, ReportPanel } from "components/PortalDashboard";
import ReportDateRange from "components/PortalDashboard/ReportDateRange";
import useAuthStore from "store/authStore";
import { BsJournalBookmark } from "react-icons/bs";


import { Role } from "utils/server-constants/roles";

const PublisherBookPerformance = ({ userId }) => {
	const [fromDate, setFromDate] = useState(null);
	const [toDate, setToDate] = useState(null);

	const result = useFetchPublisherBookPerformance(
		{
			from_date: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
			to_date: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
		},
		userId
	);

	const hasRoles = useAuthStore((state) => state.hasRoles);

    const response = result.data;
    return (
        <ReportPanel skeleton={{ variant: 'books', count: 1 }} title="Book performance" description="Discover which books are reaching your readers." result={result} filters={<ReportDateRange id="publisher-performance" {...{ fromDate, toDate, setFromDate, setToDate }} />}>

			<div className="portal-book-performance">
				<div
					className="portal-most-read"
				>
					<p className="font-bold text-sm p-2 rounded-t-lg w-full bg-gradient-to-b from-gray-200 to-gray-50 ">
						Most read book
					</p>

					{response?.data?.mostReadBook ? (
						<BookCard
							bookId={response?.data?.mostReadBook?.id}
							title={response?.data?.mostReadBook?.title}
							author={response?.data?.mostReadBook?.author}
							price={response?.data?.mostReadBook?.price}
							isbn={response?.data?.mostReadBook?.isbn}
							description={response?.data?.mostReadBook?.description}
							sellable={response?.data?.mostReadBook?.sellable}
							onSubscription={response?.data?.mostReadBook?.subscription}
							isActive={response?.data?.mostReadBook?.is_active}
							isFree={response?.data?.mostReadBook?.isFree}
							credits={response?.data?.mostReadBook?.credits}
							bookCover={response?.data?.mostReadBook?.book_cover?.url}
							bookUrl={response?.data?.mostReadBook?.book_file?.url}
							category={response?.data?.mostReadBook?.category}
							genres={response?.data?.mostReadBook?.genres?.[0]}
							isAdmin={hasRoles([Role.SuperAdmin, Role.Admin])}
							className="items-stretch mb-2 "
						/>
					) : (
						<p className="flex items-center justify-center pt-4">
							No books read
						</p>
					)}
				</div>

                <div className="portal-metrics">
                    <MetricCard label="Books purchased" value={response?.data?.numberOfBooksPurchased} icon={<BsJournalBookmark />} />
                    <MetricCard label="Books accessed" value={response?.data?.numberOfBooksAccessed} icon={<BsJournalBookmark />} />
                </div>
            </div>
        </ReportPanel>
    );
};

export default PublisherBookPerformance;
